import { Config } from "../../core/config/config";

export function getAuthorizeRedirectUrl(): string {
  return Config.AUTH_REDIRECT_WEB_CLIENT_SCHEME;
}
